var plugin_rtlignore_default = {
  "alignLeft": "DxK02",
  "textWrapNowrap": "pDsB5",
  "alignRight": "eCwVQ",
  "alignCenter": "u65uf",
  "sizeFullWidth": "_3i29G",
  "renderedInTable": "vEk-y",
  "sizeOriginal": "McgBb",
  "sizeContent": "xCmu3",
  "sizeSmall": "byn1l",
  "sizeSmallCenter": "_5M4f-",
  "flex": "paVlE",
  "atomic": "cQst3",
  "embed": "iQTpz",
  "horizontalScrollbar": "-QVRb",
  "pluginContainerMobile": "SaeZ7"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
